module.exports = __webpack_public_path__ + "7006f6d55e765d8fe721f7fe14101187.png";